import { BillingAccountService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { billingKeys } from './billingKeys';

type TCallOptions = {
  dontRedirectOnError?: boolean;
};

type TCall = <T extends { body: unknown; status: number; url: string }>(
  request: Promise<T> | (() => Promise<T>),
  options?: TCallOptions,
) => Promise<T['body']>;

type TParams = QueryFunctionContext<ReturnType<typeof billingKeys.pendingTopUpsByAccount>>;

export const createFetchPendingTopUpsQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ baId }], signal }: TParams) =>
    call(() => cancelOnSignal(BillingAccountService.getPendingTopUps({ baId }), signal), {
      dontRedirectOnError: true,
    });
